<template src="./customers.html">

</template>

<script>
import {API_URL} from '@/main'
import axios from "axios"
import router from '@/router/index.js'

export default {
  name: "Customers",
  data() {
    return {
      current_id: null,
      currentPage: 1,
      form_data: {
        id: null,
        company: '',
        address: '',
        postal_code: '',
        city: '',
        province: '',
        nation: null,
        vat: '',
        fiscal_code: '',
        contact_name: '',
        contact_phone: '',
        contact_email: '',
        active: false,
        deleted: false,
      },
      customers: [],
      customers_fields: [
        { label: '', key: 'id', sortable: false, tdStyle: { width: '0%' } },
        { label: 'Società', key: 'company', sortable: true, tdStyle: { width: '50%' } },
        { label: 'Città', key: 'city', sortable: true, tdStyle: { width: '25%' } },
        { label: 'Partita IVA', key: 'vat', sortable: true, tdStyle: { width: '15%' } },
        { label: 'Attiva', key: 'active', sortable: true, tdStyle: { width: '5%' } },
        { label: '', key: 'delete', sortable: true, tdStyle: { width: '5%' } },
      ],
      nations_list: [],      
      perPage: 10,
      sortBy: '',
      sortDesc: false,
      total_rows: 0,
    }
  },
  watch: {
    currentPage: {
      handler(newPage, oldPage) {
    
        console.log(`Page changed from ${oldPage} to ${newPage}`)
      }
    }
  },   
  computed: {
    paginatedCustomers() {

      return this.customers
    },
    totalRows() {this.totalRows = this.totalRows / this.perPage

      return this.customers.length
    }
  },  
  mounted() {

    this.loadNationsList()
    this.loadCustomersList()
  },
  methods: {
    cancelCustomer() {

      this.current_id = null
      this.form_data = {
        company: '',
        address: '',
        postal_code: '',
        city: '',
        province: '',
        nation: null,
        vat: '',
        fiscal_code: '',
        contact_name: '',
        contact_phone: '',
        contact_email: '',
        active: false,
        deleted: false,        
      }
    },
    handlePageChange(page) {

      this.currentPage = page
      this.$nextTick(() => {
        
        this.loadCustomersList()
      })
    },    
    async insertCustomer() {

      const url = API_URL+"customers/CustomersDetail/"
      console.debug("form_data", this.form_data)
      const response = await axios.post(url, this.form_data)
      this.cancelCustomer()
      this.loadCustomersList()
    },
    async loadCustomersList() {

      const url = API_URL + "customers/CustomersList/"
      const axiosInstance = axios.create({
        headers: {
          'User-ID': localStorage.getItem('User_id'),
          'token': localStorage.getItem('Token'),
        },
      })
      try {

        const response = await axiosInstance.get(url)
        this.customers = response.data.map(customer => ({
          id: customer.id,
          company: customer.company,
          address: customer.address,
          postal_code: customer.postal_code,
          city: customer.city,
          province: customer.province,
          nation: customer.nation,
          vat: customer.vat,
          fiscal_code: customer.fiscal_code,
          contact_name: customer.contact_name,
          contact_phone: customer.contact_phone,
          contact_email: customer.contact_email,
          active: customer.active,
          deleted: customer.deleted,
        }))
        this.total_rows = this.customers.length
      } 
      catch(error) {
      
        console.log('Failed to load customers list:', error)
      }      
    },
    async loadNationsList() {

      const url = API_URL + "geographic/NationsList/?active_only=true"
      const headers = {
        'User-ID': localStorage.getItem('User_id'),
        'token': localStorage.getItem('Token'),
      }
      
      try {

        const response = await axios.get(url, {headers: headers})
        console.debug("response", response.data)

        this.nations_list = response.data.map(nation => ({
          value: nation.id,
          text: nation.nation,
        }))        
      } 
      catch(error) {
      
        console.log('Failed to load nations list:', error)
      }      
    },    
    onPageChange(page) {
      
      this.currentPage = page
      this.$nextTick(() => {
        
        this.loadCustomersList()
      })
    },    
    onPerPageChange(newPerPage) {
    
      this.perPage = newPerPage
      this.currentPage = 1
      this.loadCustomersList()
    },
    onSortChanged(ctx) {
      
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
    },    
    async selectCustomer(row) {

      this.current_id = row.id
      const url = API_URL+"customers/CustomersDetail/"+row.id+"/"
      const headers = {
        'User-ID': localStorage.getItem('User_id'),
        'token': localStorage.getItem('Token'),
      }
      const response = await axios.get(url, {headers: headers})
      this.form_data = response.data
    },    
    async updateCustomer() {

      const url = API_URL+"customers/CustomersDetail/"+this.current_id+"/"
      const headers = {
        'User-ID': localStorage.getItem('User_id'),
        'token': localStorage.getItem('Token'),
      }
      const response = await axios.patch(url, this.form_data, {headers})
      this.cancelCustomer()
      this.loadCustomersList()
    },
  },
}

</script>